export const blogs = {
    blogsFeedCreateInputPlaceholder: 'Write a post...',
    blogsFeedSearchInputPlaceholder: 'Search',
    blogsFeedPostOwnerCurtainEditTitle: 'Edit post',
    blogsFeedPostOwnerCurtainDeleteTitle: 'Delete post',
    blogsFeedEditedPostSavedAlertText: 'Post saved!',
    blogsFeedEditedPostDeletedAlertText: 'Post deleted!',
    blogsFeedShareCurtainOptionTitle: 'Copy link',
    blogsFeedPostLinkCopiedAlertText: 'Link copied!',
    blogsFeedOthersPostCurtainOptionCopyTitle: 'Copy link',
    blogsFeedOthersPosLinkCopiedAlertText: 'Link copied!',
    blogsFeedOthersPostCurtainOptionFlagTitle: 'Flag content',
    blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Delete post',
    blogsFeedPostDeletePopupTitle: 'Delete',
    blogsFeedPostDeletePopupText: 'Delete this post?',
    blogsFeedPostDeletePopupCancelButtonTitle: 'Cancel',
    blogsFeedPostDeletePopupConfirmButtonTitle: 'Confirm',
    blogsFeedPostDeeletedAlertText: 'Post deleted!',
    blogsPostDetailsHeaderTitle: 'Post',
    postFeedPostLikesText: 'Likes',
    postFeedPostCommentsText: 'Comments',
    postFeedPostNoLikesText: 'There are no likes yet',
    postFeedPostLeaveFirstLikeText: 'You can leave the first one',
    blogsFeedPostDetailsNoCommentsText: 'There are no comments yet',
    blogsFeedPostDetailsFirstCommentText: 'You can leave the first one',
    blogsFeedPostDetailsShareOptionTitle: 'Copy link',
    blogsFeedPostDetailsSharePostCopiedAlertText: 'Link copied!',
    blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copy link',
    blogsFeedPostDetailsCopiedAlertText: 'Link copied!',
    blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Flag content',
    blogsPostDetailsFlagCurtainOptionSpamTitle: 'Flag',
    blogsPostDetailsReportedCurtainText: 'Content reported',
    blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Edit comment',
    blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Delete comment',
    blogsPostDetailsEditedCommentSavedAlertText: 'Comment saved!',
    postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Delete comment',
    postDetailsOtherUsersCommentDeletadAlertText: 'Comment deleted!',
    postDetailsDeleteCommentPopupTitle: 'Delete',
    postDetailsDeleteCommentPopupText: 'Delete this comment?',
    postDetailsDeleteCommentPopupCancelButtonTitle: 'Cancel',
    postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirm',
    postDetailsCommDeletedAlertText: 'Comment deleted!',
    postDetailsCommentUserCurtainOptionTitle: 'Flag comment',
    blogsCreatePostCurtainTitle: 'New post',
    blogsCreatePostCurtainBodyPlaceholder: 'Place your text here...',
    blogsCreatePostPublishButtonTitle: 'Publish',
    blogsCreatePostUploadSlallerImageAlertText: 'You can upload no more than {size} MB at once',
    blogsPostSavedAlertText: 'Post saved!',
    blogsCreatePostAddLocationCurtainTitle: 'Location',
    blogsCreatePostAddLocationCurtainInputPlaceholder: 'Location name',
    blogsCreatePostEditLocationCurtainText: 'Edit location',
    blogsDeleteLocation: 'Delete location',
    blogsDiscardPostPopupTitle: 'Draft',
    blogsDiscardPostPopupText: 'Discard this Draft?',
    blogsDiscardPostPopupCancelButtonTitle: 'Cancel',
    blogsDiscardPostPopupCofirmButtonTitle: 'Confirm',
    blogsNewPostCreatePollTitle: 'Create poll',
    blogsNewPostCreatePollTitleInputPlaceholder: 'Title',
    blogsNewPostCreatePollOptionInputPlaceholder: 'Option',
    blogsNewPostCreatePollAddButtonTitle: 'Add option',
    blogsNewPostCreatePollCreateButtonTitle: 'Create',
    blogsCreatePostPollTitleBlankAlertText: 'Title can’t be blank!',
    blogsCreatePostPollOptionBlankAlertText: 'Option can’t be blank!',
    blogsCreatePostPollLongTitleAlertText: 'Title should contain at most {length} characters',
    blogsCreatePostPollLongOptionAlertText: 'Option should contain at most {length} characters',
    blogsCreatePostPollEditOptionTitle: 'Edit poll',
    blogsCreatePostPollRemoveOptionTitle: 'Remove poll',
    blogsPostPollInfoVotesText: 'votes',
    blogsPostPollInfoEditVoteText: 'Edit vote',
    blogsPostPollFinishPollText: 'Finish the poll',
    blogsPostPollFinishedPollText: 'Finished',
    blogsPostPollInProgresslText: 'In Progress',
    blogsFinishPollCurtainTitle: 'Finish the poll',
    blogsFinishPollCurtainText: 'Users won’t be able to vote after the poll is finished.',
    blogsFinishPollCurtainCancelButtonTitle: 'Cancel',
    blogsFinishPollCurtainConfirmlButtonTitle: 'Confirm',
    blogsPollInfoPollVotesCurtainTitle: 'Poll Votes',
    blogsEditPostCurtainTitle: 'Edit post',
    blogsEditPostCurtainNoTextBodyPlaceholder: 'Place your text here...',
    blogsEditPostCurtainSaveButtonTitle: 'Save',
    blogsEditPostSavedAlertText: 'Post saved!',
    blogsError: 'Something went wrong!',
    blogsAt: 'at',
    blogsSeeMore: 'See more...',
    blogsMaxAttachments: 'You have exceeded max number of attachments. Max attachments is {length}',
    blogsReply: 'Reply',
    blogsAddCover: 'Add Cover Image'
}